import { createBrowserRouter } from 'react-router-dom';

import Root from '../components/Root';
import Dashboard from '../components/dashboard/Dashboard';
import Login from '../components/Authentication/Login';
import { Profile } from '../components/Profile';
import ScormUpload from '../components/Scorm/ScormUpload';
import ScormFilesList from '../components/Scorm/ScormUploads/ScormFilesList';
import ScormFileExplorerWrapper from '../components/Scorm/ScormFileExplorerWrapper';
import ScormProcessesList from '../components/Scorm/ScormProcess/ScormProcessesList';
import ApiIntegration from '../components/ApiIntegration/ApiIntegration';
import DashboardAPIKeys from '../components/dashboard/DashboardAPIKeys';
import DashboardSCORMFiles from '../components/dashboard/DashboardSCORMFiles';
import RepositoryList from '../components/Repository/RepositoryList';
import ForgetPassword from '../components/Authentication/ForgetPassword';
import ResetPassword from '../components/Authentication/ResetPassword';
import BatchList from '../components/Repository/BatchList';
import Pricing from '../components/subscription/Pricing';
import SupportDocs from '../components/SupportDocs/SupportDocs';
import Administration from '../components/Administration';

// Import wrapper components
import RepositoryBatchListWrapper from '../components/wrappers/RepositoryBatchListWrapper';
import RepositoryBatchFileListWrapper from '../components/wrappers/RepositoryBatchFileListWrapper';
import BatchPackageListWrapper from '../components/wrappers/BatchPackageListWrapper';
import Signup from '../components/Authentication/Signup';
import VerifyEmail from '../components/Authentication/VerifyEmail';
import { PageNotFound } from '../components/PageNotFound';
import TermsConditions from '../components/TermsConditions';
import { TeamsApps } from '../components/AI-Integration';
import SetPassword from '../components/Authentication/SetPassword';

const DEFAULT_PAGE_SIZE = 10;

export const ROUTES = {
    ROOT: '/',
    LOGIN: '/login',
    SIGNUP: '/signup',
    VERIFY_EMAIL: '/verify-email',
    FORGET_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    SET_PASSWORD: '/set-password',
    DASHBOARD: '',
    PROFILE: '/profile',
    SCORM_UPLOAD: '/scorm-upload',
    SCORM_FILES: '/scorm-files',
    SCORM_EXPLORER: '/scorm-explorer/:scormId',
    SCORM_PROCESSES: '/scorm-processes',
    API_INTEGRATION: '/api-integration',
    API_MANAGEMENT: '/api-management',
    SCORM_COURSES: '/scorm-courses',
    REPOSITORY_MANAGEMENT: '/repository-management',
    REPOSITORY_BATCHES: '/repository-management/:repo_id/batches',
    REPOSITORY_BATCH_FILES: '/repository-management/:repo_id/batches/:batch_id/files',
    BATCHES: '/batch-management',
    BATCH_PACKAGES: '/batch-management/:batch_id/packages',
    PRICING: '/pricing',
    TERMS_CONDITIONS: '/terms-and-conditions',
    APPS: '/apps',
    SUPPORT_DOCS: '/support-docs',
    ADMINISTRATION: '/administration',
};

const router = createBrowserRouter([
    {
        path: ROUTES.ROOT,
        element: <Root />,
        children: [
            { path: ROUTES.DASHBOARD, element: <Dashboard /> },
            { path: ROUTES.PROFILE, element: <Profile /> },
            { path: ROUTES.SCORM_UPLOAD, element: <ScormUpload /> },
            { path: ROUTES.SCORM_FILES, element: <ScormFilesList /> },
            { path: ROUTES.SCORM_EXPLORER, element: <ScormFileExplorerWrapper /> },
            { path: ROUTES.SCORM_PROCESSES, element: <ScormProcessesList /> },
            { path: ROUTES.API_INTEGRATION, element: <ApiIntegration /> },
            { path: ROUTES.API_MANAGEMENT, element: <DashboardAPIKeys /> },
            { path: ROUTES.SCORM_COURSES, element: <DashboardSCORMFiles pageSize={DEFAULT_PAGE_SIZE} /> },
            { path: ROUTES.REPOSITORY_MANAGEMENT, element: <RepositoryList pageSize={DEFAULT_PAGE_SIZE} /> },
            { path: ROUTES.REPOSITORY_BATCHES, element: <RepositoryBatchListWrapper /> },
            { path: ROUTES.REPOSITORY_BATCH_FILES, element: <RepositoryBatchFileListWrapper /> },
            { path: ROUTES.BATCHES, element: <BatchList /> },
            { path: ROUTES.BATCH_PACKAGES, element: <BatchPackageListWrapper /> },
            { path: ROUTES.PRICING, element: <Pricing /> },
            { path: ROUTES.SUPPORT_DOCS, element: <SupportDocs /> },
            { path: ROUTES.ADMINISTRATION, element: <Administration /> },
        ],
    },
    { path: ROUTES.LOGIN, element: <Login /> },
    { path: ROUTES.VERIFY_EMAIL, element: <VerifyEmail /> },
    { path: ROUTES.FORGET_PASSWORD, element: <ForgetPassword /> },
    { path: ROUTES.RESET_PASSWORD, element: <ResetPassword /> },
    { path: ROUTES.SIGNUP, element: <Signup /> },
    { path: ROUTES.TERMS_CONDITIONS, element: <TermsConditions /> },
    { path: ROUTES.SET_PASSWORD, element: <SetPassword /> },
    { path: '*', element: <PageNotFound /> },
]);

export default router;
